<template>
    <div class="marginCon">
        <Card>
            <div class="search-div flexC">
                 <div class="search-div-item flexC">
                   <div class="labelText">{{$t("push.serialNumbers")}}</div>
                   <!-- <Input class="input-div" :placeholder='$t("inputPlaceholder")' clearable v-model="searchObj.id" ></Input> -->
                    <InputNumber class="input-div" :min="1" :precision='0'  :placeholder='$t("inputPlaceholder")' clearable v-model="searchObj.id" ></InputNumber>
                </div>
    
                 <div class="search-div-item flexC">
                   <div class="labelText">{{$t("push.receiverGroup")}}</div>
                    <Select  :placeholder='$t("selectPlaceholder")'  clearable class="input-div" v-model="searchObj.receiverGroup" >
                        <Option v-for="(item, index) in searchObjArr.userGroups" :value="item.id" :key="index">{{item.groupName}}</Option>
                    </Select>
                </div>
                <div class="search-div-item">
                 <Button type="info" @click="searchItem"  icon="ios-search" style="margin-top:5px;height:44px;line-height:44px;width:96px;border-radius: 10px;">{{$t('search')}}</Button>
                </div>
            </div>
            <div class="top">
                <Button type="success" :disabled="buttonList.addDisabled" @click="addData(1)" style="margin-right:8px;">{{$t("push.addButton")}}</Button>
            </div>
             <Table :columns="titleName" :data="tableList.tableData" @on-sort-change="sortCustom" ref="selection" @on-selection-change="selectChange"  :loading='loading'></Table>
              <Page @on-change="changePage" @on-page-size-change="changeSize" :total="page.total" show-sizer :show-total="true" :current="page.current" :page-size="page.pageSize" :age-size-opts="[10,20,30,50]" placement="top" class="pages"/>
              <!-- 编辑 / 添加  模态框组件 -->
               <ModelBox :showModel.sync="addBox.showModel" :fn="addBox.callbackFn" :type="type" :editFormData="addBox.editFormData"></ModelBox>
    
            
        </Card>
    </div>
</template>
<script>
import common from '@/common/common.js';
import ModelBox from './component/addModel';
import moment from 'moment';
import { mapState } from 'vuex'

    export default {
        name: "merchantAdmin",
        components: {
            ModelBox
        },
        data(){
            return{
                selectChangeData: [],
                loading: true,
                type:1,//弹框打开类型 1添加 2编辑
                tableList:{//表格组
                    hasSelectData:{},//已选中的行的数据
                    tableData: []//表格数据
                },
                addBox:{//规格弹框组-新增
                    showModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                    editFormData:{},//编辑时传入的现有数据
                },
                detailBox:{//规格弹框组-详情
                    showModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                    editFormData:{},//编辑时传入的现有数据
                },
                buttonList:{//按钮组
                    addDisabled:false,//添加按钮是否禁用
                    editDisabled:true,//编辑按钮是否禁用
                    delDisabled:true,//删除按钮是否禁用
                },
                page:{//分页排序
                    total:0,//总条数
                    pageSize:10,//每页条数
                    current:1,//当前页
                    key:'created_at',
                    order:'desc'
                },
                searchObjArr:{
                    userGroups:[
                       
                    ],
                },
                searchObj:{
                    receiverGroup:"",
                    id:null
                },
               
            }
        },
        computed:{
            ...mapState(['selectId']),
            titleName(){
                return [
                    {
                        title:this.$t('push.titleName.id'),
                        'title-zh-CN':'序列号',
                        'title-en-US':'Serial number',
                        key: 'id',
                        sortable: true,
                        minWidth: 160
                    },
                    {
                        title:this.$t('push.titleName.pushTime'),
                        'title-zh-CN':'推送时间',
                        'title-en-US':'Push time',
                        key: 'pushTime',
                        minWidth: 180,
                         render:(h, params)=>{
                            let stext = moment(params.row.pushTime*1).format('YYYY-MM-DD HH:mm:ss')
                             return h('div',stext || '')
                        }
                    },
                    {
                        title:this.$t('push.titleName.sendNumber'),
                        'title-zh-CN':'推送量',
                        'title-en-US':'Send',
                        key: 'sendNumber',
                        sortable: true,
                        minWidth: 100
                    },
                    {
                        title:this.$t('push.titleName.readNumber'),
                        'title-zh-CN':'阅读量',
                        'title-en-US':'Read',
                        key: 'readNumber',
                        minWidth: 100
                    },
                    {
                        title:this.$t('push.titleName.pushMessage'),
                        'title-zh-CN':'消息内容',
                        'title-en-US':'Message',
                        key: 'pushMessage',
                        minWidth: 260,
                        render:(h, params)=>{
                            let stext = params.row.pushMessage
                            return h('div',{
                                attrs:{
                                    title:stext
                                }
                            },stext || '')
                        }
                    },
                    {
                        title:this.$t('push.titleName.groupName'),
                        'title-zh-CN':'接收用户',
                        'title-en-US':'Receiver',
                        key: 'groupName',
                        minWidth: 180
                    }
                ]
            },
        },
        created() {
            this.getData();
            this.getSelect();
        },
        methods: {
            getSelect(){

                this.axios.post(this.config.urlArray.userGroups, {dealerId:this.selectId}).then((result) => {
                    // common.ajaxMsg(result.data);
                    let resData = result.data.data
                    //处理数组
                    this.searchObjArr.userGroups = resData
                }).catch((err) => {
                    // common.msg('error','获取失败',()=>{})
                });
           
            },
            selectT(val){//选择日期
                // console.log(val)
                this.searchObj.loan_time = val
                this.searchObj.loan_time = val.join(',')
            },
           
            searchItem(){ //搜索
                this.loading = true
                this.page.current = 1
                this.page.pageSize = 10
                this.getData()
            },
            getData() {//获取数据
                let getData = {
                    params: {
                        page: this.page.current,
                        pagesize: this.page.pageSize,
                        sortfield: this.page.key,
                        ascDesc: this.page.order,
                        dealerId:this.selectId
                    }
                }
                Object.assign(getData.params,this.searchObj)
                this.axios.post(this.config.urlArray.pushes, getData.params).then((result) => {
                    common.ajaxMsg(result.data);
                    let resData = result.data.data.pushList
                    //处理数组
                    this.tableList.tableData = resData
                    this.page.total = result.data.data.count
                    this.loading = false
                }).catch((err) => {
                    // common.msg('error','获取失败',()=>{})
                });
            },
            sortCustom(data) {//自定义排序
                this.page.key = data.key
                this.page.order = data.order
                this.getData()
            },
            addData(type) {  //添加或编辑数据
                this.addBox.showModel = true
                this.type = type
                if(type == 2) {
                    this.addBox.editFormData = this.tableList.hasSelectData
                }
                this.addBox.callbackFn = () => {//回调处理
                    //重新载入
                    this.clearbtnStatus()
                    this.addBox.showModel = false;
                    this.getData();
                }
            },
            showDetail(row){
                this.detailBox.showModel = true
                this.detailBox.editFormData = row
                this.detailBox.callbackFn = () => {//回调处理
                    //重新载入
                    this.clearbtnStatus()
                    this.detailBox.showModel = false;
                    // this.getData();
                }
            },
            selectChange(res) { //控制编辑和删除按钮的可用状态
                this.selectChangeData = res
                if(res.length == 1){
                    this.buttonList.editDisabled = this.buttonList.delDisabled = false
                    this.tableList.hasSelectData = res[0]
                }else{
                    this.buttonList.editDisabled = this.buttonList.delDisabled = true
                    this.tableList.hasSelectData = {}
                }
            },
            changePage(nowpage) {//切换分页
                this.page.current = nowpage;
                this.getData();
            },
            changeSize(nowSize) {//切换每页显示条数
                this.page.pageSize = nowSize
                this.page.current = 1
                this.getData()
            },
            clearbtnStatus() { //删除后清空编辑数据 与按钮状态
                this.buttonList.delDisabled = true
                this.buttonList.editDisabled = true
                this.addBox.editFormData ={}
                this.tableList.hasSelectData = {}
            },
        }
    }
</script>

<style lang="less" scoped>
 .search-div{
     flex-wrap: wrap;
    //  background-color: #fff;
    //  padding: 34px 40px ;
     background: #FFFFFF;
    //  margin: 20px 40px;
     border-radius: 14px;
     .search-div-item{
         margin-right: 20px;
         span{
             margin-right: 30px;
         }
     }
     /deep/ .ivu-select-single .ivu-select-selection .ivu-select-placeholder, .ivu-select-single .ivu-select-selection .ivu-select-selected-value{
         height:44px;
         line-height: 44px;
     }
     /deep/ .ivu-select-single .ivu-select-selection .ivu-select-selected-value{
         height:44px;
         line-height: 44px;
     }
      /deep/ .ivu-select-single .ivu-select-selection{
        height: 44px;
        width: 200px;
     }
     /deep/  .ivu-input{
          height: 44px;
         line-height: 44px;
     }
     /deep/ .ivu-input-icon{
          height:44px;
         line-height: 44px;
     }

      /deep/  .ivu-input-number-input-wrap{
         height:44px;
         line-height: 44px;
     }
      /deep/  .ivu-input-number{
         height:44px;
         line-height: 44px;
     }
      /deep/  .ivu-input-number-handler{
         height:22px;
         line-height:22px;
     }
      /deep/ .ivu-input-number-handler-up-inner{
         line-height:22px;
     }
      /deep/ .ivu-input-number-handler-down-inner{
         line-height:22px;
     }
 }
 .labelText{
     line-height: 54px;
     height: 54px;
     flex-shrink: 0;
     margin-right: 10px;
 }
</style>
